import React, { useState } from "react";
import $ from "jquery";
import moment from "moment/moment";

const FilterDateModal = ({
  closeModal,
  filterModalDescTxt,
  setFilterData,
  filterData,
  setApiCalled,
  getFilterData,
  dateError,
  setDateError,
  error,
  setError,
}) => {
  const [loader, setLoader] = useState(false);

  const duration = [
    { name: "Minutes", value: "minutes" },
    { name: "Seconds", value: "seconds" },
  ];

  const call_type = [
    { name: "NOANSWER", value: "NOANSWER" },
    { name: "ANSWER", value: "ANSWER" },
    // { name: "CHANUNAVAIL", value: "CHANUNAVAIL" },
    { name: "CANCEL", value: "CANCEL" },
    { name: "BUSY", value: "BUSY" },
  ];

  const handleStartDateErrors = (value) => {
    setError("");
    if (filterData?.end_date === null) {
      setDateError("End Date is Missing");
    }
    if (filterData?.end_date !== null && value !== "") {
      if (value > filterData?.end_date) {
        setDateError("Start date must be lesser than end date");
      } else {
        setDateError("");
      }
    }
  };
  const handleEndDateErrors = (value) => {
    setError("");
    if (filterData?.start_date === null) {
      setDateError("Start Date is Missing");
    }
    if (filterData?.start_date !== null && value !== "") {
      if (value < filterData?.start_date) {
        setDateError("End date must be greater than Start date");
      } else {
        setDateError("");
      }
    }
  };

  const clearFilter = () => {
    // setLoader(true);
    $("#fromDate").val("");
    $("#toDate").val("");
    setApiCalled(true);
    setFilterData({
      start_date: null,
      end_date: null,
      clientNumber: null,
      campaignName: null
    });
  };

  return (
    <div
      className="customModal ModalStyle uk-flex-top uk-open uk-flex uk-flex uk-open"
      uk-modal="esc-close: false; bg-close: false"
    >
      <div className="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
        <div className="filterModalContent">
          <div className="modalHeading">
            <h4>Search filter</h4>
          </div>
          <div className="modalForm">
            <div className="formHeading">
              <span>{filterModalDescTxt}</span>
            </div>
            <form
              action=""
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <div className="uk-grid uk-grid-small" uk-grid="">
                <div className="uk-width-1-2">
                  <div className="formInputs">
                    <label htmlFor="from_date">Start date</label>
                    <input
                      id="fromDate"
                      type="date"
                      value={filterData?.start_date}
                      onChange={(e) => {
                        setFilterData({
                          ...filterData,
                          start_date: e.target.value,
                        });
                        handleStartDateErrors(e.target.value);
                      }}
                      className="uk-input"
                    />
                  </div>
                </div>
                <div className="uk-width-1-2">
                  <div className="formInputs">
                    <label htmlFor="to_date">End date</label>
                    <input
                      id="toDate"
                      type="date"
                      value={filterData?.end_date}
                      onChange={(e) => {
                        setFilterData({
                          ...filterData,
                          end_date: e.target.value,
                        });
                        handleEndDateErrors(e.target.value);
                      }}
                      className="uk-input"
                    />
                  </div>
                </div>
                {dateError !== "" && (
                  <div className="uk-width-1-1 formErrors">{dateError}</div>
                )}

                {error !== "" && (
                  <div className="uk-width-1-1 formErrors">{error}</div>
                )}

<div className="uk-width-1-2">
                  <div className="formInputs">
                    <label htmlFor="city">Client number</label>
                    <input
                      type="text"
                      placeholder="please enter client number"
                      defaultValue={filterData.clientNumber}
                      className="uk-input"
                      onChange={(e) => {
                        setFilterData({
                          ...filterData,
                          clientNumber: e.target.value,
                        });
                        // handleStartDateErrors(e.target.value);
                      }}
                      
                    />
                  </div>
                </div>

                <div className="uk-width-1-2">
                  <div className="formInputs">
                    <label htmlFor="city">Campaign Name</label>
                    <input
                      type="text"
                      placeholder="please enter campaign name"
                      defaultValue={filterData.campaignName}
                      className="uk-input"
                      onChange={(e) => {
                        setFilterData({
                          ...filterData,
                          campaignName: e.target.value,
                        });
                        // handleStartDateErrors(e.target.value);
                      }}
                     
                    />
                  </div>
                </div>

                <div className="uk-width-1-2">
                  <div className="clearFilterBtn">
                    <button
                      className="exportData-button"
                      style={{ margin: "0px" }}
                      type="button"
                      onClick={() => clearFilter()}
                    >
                      {loader ? (
                        <div uk-spinner="" className="loader">
                          Clearing
                        </div>
                      ) : (
                        " Clear filter"
                      )}
                    </button>
                  </div>
                </div>
                <div className="uk-width-1-2">
                  <div className="btnwrp" style={{ float: "right" }}>
                    <button
                      type="button"
                      className="exportData-button"
                      onClick={closeModal}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="exportData-button"
                      onClick={() => getFilterData()}
                    >
                      {loader ? (
                        <div
                          uk-spinner=""
                          className="loader loaderfilter"
                        ></div>
                      ) : (
                        "Search"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterDateModal;
